import { useStore as e } from "/home/runner/work/oko-web/oko-web/node_modules/zustand/esm/react.mjs";
import { createStore as t } from "/home/runner/work/oko-web/oko-web/node_modules/zustand/esm/index.mjs";
import { useShallow as n } from "/home/runner/work/oko-web/oko-web/node_modules/zustand/esm/react/shallow.mjs";
import { devtools as r } from "/home/runner/work/oko-web/oko-web/node_modules/zustand/esm/middleware.mjs";
//#region src/lib/stores/cart-store/useCartStore.ts
var i = t(r((e, t) => ({
	cart: void 0,
	products: [],
	currency: "USD",
	cartQuantity: 0,
	setCart: (t) => {
		e({ cart: t });
	},
	setProducts: (t) => {
		e({ products: t });
	},
	setCurrency: (t) => {
		e({ currency: t });
	},
	updateCartTotalPrice: () => t().products.reduce((e, t) => e + t.variants[0].unitPrice.amount * t.quantity, 0),
	updateCartQuantity: (t) => {
		e({ cartQuantity: t });
	},
	checkout: () => {
		e({
			cart: void 0,
			products: [],
			cartQuantity: 0
		});
	}
}))), a = (t) => e(i, n(t));
//#endregion
export { i as cartStore, a as useCartStore };
